import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const gameRoutes: RouteObject[] = [
  {
    path: '/games',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Games',
      crumb: () => ({ label: 'Games', to: '/games' })
    },
  },
];

export default gameRoutes;
